export const AndroidImportance = {
  NONE: 0,
  MIN: 1,
  LOW: 2,
  DEFAULT: 3,
  HIGH: 4,
  MAX: 5,
  UNSPECIFIED: -1000,
}

export const EventType = { UNKNOWN: 0 }

export const AuthorizationStatus = {
  NOT_DETERMINED: 0,
  DENIED: 1,
  AUTHORIZED: 2,
  PROVISIONAL: 3,
  EPHEMERAL: 4,
}

export const TriggerType = {
  TIMESTAMP: "timestamp",
  INTERVAL: "interval",
  CALENDAR: "calendar",
}

// No-op implementations (do nothing on web)
export async function requestPermission() {
  return { authorizationStatus: AuthorizationStatus.AUTHORIZED }
}

export async function createChannel() {
  return "web-mock-channel"
}
export async function deleteChannel() {}
export async function displayNotification() {}
export async function cancelNotification() {}
export async function getInitialNotification() {
  return null
}

export async function createTriggerNotification() {
  return
}
export async function cancelTriggerNotification() {
  return
}
export async function getTriggerNotifications() {
  return []
}

export function onForegroundEvent() {
  return () => {}
}
export function onBackgroundEvent() {}

export default {
  AndroidImportance,
  EventType,
  AuthorizationStatus,
  TriggerType,
  requestPermission,
  createChannel,
  deleteChannel,
  displayNotification,
  cancelNotification,
  getInitialNotification,
  createTriggerNotification,
  cancelTriggerNotification,
  getTriggerNotifications,
  onForegroundEvent,
  onBackgroundEvent,
}
